import {ASync} from "../PA.Core/Basic/ASync";
import {IPolicy} from "../PA.Core/PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import * as _ from 'lodash'
import {PAEntity} from "../PA.Core/PAEntity";
import {ModelCoefficientBO} from "./ModelCoefficientBO";


export class ModelCoefficientPolicy
    implements IPolicy
{
    _modelCoeff: ModelCoefficientBO
    _PolicyChanged: BehaviorSubject<IPolicy>

    _bColumnCreatedInd: boolean
    _bCoefficientIdEditable: boolean
    _bCoefficientTypeEditable: boolean

    _isLoaded: boolean

    constructor(modelCoefficientBO: ModelCoefficientBO) {
        this._modelCoeff = modelCoefficientBO
        this._PolicyChanged = new BehaviorSubject<IPolicy>(this)

        this._bColumnCreatedInd = false
        this._bCoefficientIdEditable = false
        this._bCoefficientTypeEditable = false

        this._isLoaded = false
    }

    get OnLoadComplete(): Promise<void> {
        const self = this

        if (self._isLoaded)
            return ASync.resolve()

        return new Promise<void>((resolve, error) => {
            self._isLoaded = true
            self._modelCoeff.OnLoadComplete
                .then((ignore) => {
                    return self.refreshPolicy()
                })
                .then((ignore) => {
                })
                .catch((err) => {
                    console.log(err)
                })
            resolve();
        })
    }


    get bCoefficientIdEditable(): boolean {
        return this._bCoefficientIdEditable;
    }

    get bCoefficientTypeEditable(): boolean {
        return this._bCoefficientTypeEditable;
    }


    get PolicyChanged(): BehaviorSubject<IPolicy> {
        return this._PolicyChanged
    }

    async refreshPolicy(bForce?: boolean): Promise<void> {
        const self = this

        const bo = self._modelCoeff


        if((!self._isLoaded)  && (!bForce))
            return



        //-- If new record,
        if (self._modelCoeff.WB_ModelCoefficient.isActiveNew) {
            self._bColumnCreatedInd = false;
            self._bCoefficientIdEditable = true;
            self._bCoefficientTypeEditable = true;
            self._isLoaded = true
            self._PolicyChanged.next(self)
            return
        }

        if (!self._modelCoeff.WB_ModelCoefficient.isActive) {
            self._bColumnCreatedInd = false;
            self._bCoefficientIdEditable = false;
            self._bCoefficientTypeEditable = false;
            self._isLoaded = true
            self._PolicyChanged.next(self)
            return
        }

        if (_.isEmpty(bo.WB_ModelCoefficient.cif.MODEL_COEFFICIENT_ID) || _.isEmpty(bo.WB_ModelCoefficient.cif.MODEL_COEFFICIENT_TYPE)) {
            self._bColumnCreatedInd = false;
            self._bCoefficientIdEditable = true;
            self._bCoefficientTypeEditable = true;
            self._isLoaded = true
            self._PolicyChanged.next(self)
            return
        }

        let tableName = bo.getTableName()
        let columnName = bo.WB_ModelCoefficient.cif.MODEL_COEFFICIENT_ID

        if(_.isEmpty(tableName)){
            self._bColumnCreatedInd = false;
            self._bCoefficientIdEditable = true;
            self._bCoefficientTypeEditable = true;
            self._PolicyChanged.next(self)
        } else {
            let aPAEntity = new PAEntity()
            let columnExists = await aPAEntity.checkEntityColumnExists(0, tableName, columnName)
            self._bColumnCreatedInd = columnExists
            if(columnExists){
                self._bCoefficientIdEditable = false;
                self._bCoefficientTypeEditable = false;
            } else {
                self._bCoefficientIdEditable = true;
                self._bCoefficientTypeEditable = true;
            }
        }

        self._isLoaded = true
        self._PolicyChanged.next(self)

    }

}


